<template>
    <div>
        <div
            class="flex justify-between items-center p-4 bg-white border-b border-gray-200"
        >
            <AppLogo :appName="appName" />
            <div>
                <Icon
                    name="list"
                    @click="isOpen = !isOpen"
                    class="w-6 h-6 text-gray-500 cursor-pointer"
                />
            </div>
        </div>
        <Drawer
            :raw="true"
            :show="isOpen"
            side="left"
            :showCloseButton="false"
            @close="isOpen = false"
        >
            <div class="px-6 py-4">
                <AppLogo :appName="appName" />
            </div>
            <ul class="space-y-1 px-2">
                <SidebarItem
                    iconName="home"
                    :href="RoutePathAppEnum.Root"
                    :active="currentRoute == RoutePathAppEnum.Root"
                >
                    Dashboard
                </SidebarItem>

                <SidebarDivider />

                <SidebarItem
                    iconName="user"
                    :href="RoutePathAppEnum.MyProfile"
                    :active="currentRoute == RoutePathAppEnum.MyProfile"
                >
                    My Profile
                </SidebarItem>
                <SidebarItem
                    iconName="logout"
                    as="button"
                    class="w-full"
                    @click="logoutApiFormRef?.submit()"
                >
                    Logout
                </SidebarItem>
                <ApiForm
                    :url="RoutePathAppEnum.Auth_Logout"
                    method="POST"
                    ref="logoutApiFormRef"
                />
            </ul>
        </Drawer>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import SidebarItem from '@/Shared/Layout/Admin/SidebarItem.vue'
    import SidebarDivider from '@/Shared/Layout/Admin/SidebarDivider.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface AdminMobileTopbarProps {
        appName: string
        currentRoute: string
    }

    const props = defineProps<AdminMobileTopbarProps>()
    const isOpen = ref(false)
    const logoutApiFormRef = ref<ApiFormRefType>(null)
</script>
